import {combineReducers} from '@reduxjs/toolkit';
import {
  ambientWeatherReducer,
  billingReducer,
  dataReducer,
  davisReducer,
  ecowittReducer,
  featureFlagsReducer,
  locationReducer,
  myAcuriteReducer,
  netatmoEnergyReducer,
  netatmoWeatherReducer,
  uiInteractionReducer,
  userPreferenceReducer,
  userReducer,
  weatherDataReducer,
  weatherReducer,
  weatherflowReducer,
  wundergroundReducer,
} from '@smartmixin/core';
import prefsReducer from './prefs';

export const reducerObj = {
  uiInteraction: uiInteractionReducer,
  prefs: prefsReducer,
  user: userReducer,
  userPreference: userPreferenceReducer,
  billing: billingReducer,
  featureFlags: featureFlagsReducer,
  netatmoWeather: netatmoWeatherReducer,
  netatmoEnergy: netatmoEnergyReducer,
  data: dataReducer,
  weather: weatherReducer,
  weatherData: weatherDataReducer,
  // The webapp has no location screens, but core's shared selectors do not
  // know that: `selectCoverageStations` reads the location forecast store
  // alongside the weather one, so an unregistered slice is an undefined read,
  // not an unused one (SMARTMIXIN-WEB-5C). Persisted like `weather` — it is
  // account data, not ephemeral UI.
  location: locationReducer,
  davis: davisReducer,
  weatherflow: weatherflowReducer,
  ambientWeather: ambientWeatherReducer,
  wunderground: wundergroundReducer,
  ecowitt: ecowittReducer,
  myAcurite: myAcuriteReducer,
};

const appReducer = combineReducers(reducerObj);

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    // No `ui` here: the webapp has no such reducer (mobile does). Keeping it
    // put `ui: undefined` on the object as an OWN key, and combineReducers
    // warns on Object.keys regardless of value -- the "Unexpected key" line in
    // the test output was this, not rehydration (#190).
    const {prefs, userPreference} = state;
    state = {prefs, userPreference};
  }

  return appReducer(state, action);
};

export default rootReducer;
